import * as Yup from 'yup';

export const contactValidationSchema = Yup.object().shape({
	First_Name: Yup.string().required('First Name is required'),
	Last_Name: Yup.string().required('Last Name is required'),
});
